export const ADMIN_ROUTES = [
    {
        'route' : 'Overview',
        'url': '/'
    },
    {
        'route': 'Courses',
        'url': '/courses'
    },
    {
        'route': 'Students',
        'url': '/students'
    },
    // {
    //     'route': 'Assignments',
    //     'url': '/assignments'
    // },
    // {
    //     'route': 'Teachers',
    //     'url': '/teachers'
    // },
    {
        'route': 'Admins',
        'url': '/admins'
    },
    {
        'route': 'Stores',
        'url': '/flashStores'
    }
]


export const TEACHER_ROUTES = [
    {
        'route' : 'Home',
        'url': '/'
    },
    {
        'route': 'My Classes',
        'url': '/myclasses'
    },
    {
        'route': 'Courses',
        'url': '/courses'
    },
    {
        'route': 'My Assignments',
        'url': '/myassignments'
    },
    {
        'route': 'Student Questions',
        'url': '/forum'
    }
];

export const STUDENT_ROUTES = [
    {
        'route': 'Trang chủ',
        'url':'/'
    },
    {
        'route': 'Học FlashCard',
        'url': '/courses'
    }
    // {
    //     'route': 'Assignments',
    //     'url': '/assignments'
    // },
    // {
    //     'route': 'Forum',
    //     'url': '/forum'
    // },
];